import { ProduktspecifikationDTO } from "~app/common/models/produkt/ProduktspecifikationDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ProduktDetailTexts } from "../../produkt-detail.texts";

export class ProduktDetailUppfoljningValidation {
    static init(produktspecifikation: ProduktspecifikationDTO): ValidationContext {
        const isMinWithin = (value: number, modultraffMax: number): boolean => {
            if (value < -50 || value > 50) {
                return false;
            }

            return value <= modultraffMax;
        };

        const isMaxWithin = (value: number, modultraffMin: number): boolean => {
            if (value < -50 || value > 50) {
                return false;
            }

            return value >= modultraffMin;
        };

        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                applicable: () => !ObjectUtils.isNullOrUndefined(produktspecifikation.modultraffMin),
                errorLevel: ValidationErrorLevels.error,
                expression: (value) => isMinWithin(value, produktspecifikation.modultraffMax),
                message: { text: ProduktDetailTexts.uppfoljningTab.validation.modultraffMin },
                model: () => produktspecifikation.modultraffMin,
                name: "modultraffMin",
                subscriptions: ["modultraffMax"],
                publish: true,
                verbose: true
            },
            {
                applicable: () => !ObjectUtils.isNullOrUndefined(produktspecifikation.modultraffMax),
                errorLevel: ValidationErrorLevels.error,
                expression: (value) => isMaxWithin(value, produktspecifikation.modultraffMin),
                message: { text: ProduktDetailTexts.uppfoljningTab.validation.modultraffMax },
                model: () => produktspecifikation.modultraffMax,
                name: "modultraffMax",
                subscriptions: ["modultraffMin"],
                publish: true,
                verbose: true
            }
        ]);

        return context;
    }
}
